import { createSelector as cs } from "reselect";
import { getAllCategories, getAllCategoriesWithoutProgressive, prop } from "../helpers/helpers";
import moment from "moment";
import {
    transformForAllGameBoxData,
    transformFreeRoundsData,
    transformPrizePoolData
} from "./sagas/helpers/transform";
import { isBetweenOrEqual } from "../helpers/transformRacePrizePool";
import { formatCurrencyConverter } from "../helpers/formatCurrencyConverter";
import configs from "../configs/configs";
/*import { mergeArrays } from "../utils/utils";*/

const queryParams = prop("queryParams");
const selectedGameBoxTag = prop("selectedGameBoxTag");
const gameBoxMission = prop("gameBoxMission");
const messages = prop("messages");
const casinoTournamentNextInstances = prop("casinoTournamentNextInstances");
const progressiveMissions = prop("progressiveMissions");
const expiredProgressiveMissions = prop("expiredProgressiveMissions");
/*const gameBoxRaffle = prop("gameBoxRaffle");*/
const mission = prop("mission");
/*const gameBoxRaffleTickets = prop("gameBoxRaffleTickets");*/
const inFreeSpinState = cs(queryParams, prop("inFreeSpinState"));

export const getRacesAccountResult = prop("racesAccountResult");
export const getGameUrl = prop("gameUrl");
export const getGameBoxMissionCount = prop("gameBoxMissionCount");
export const getGameInfo = prop("gameInfo");
export const getWebsiteName = cs(queryParams, prop("websiteName"));
export const getProgressiveMissions = progressiveMissions;
export const getExpiredProgressiveMissions = expiredProgressiveMissions;
export const getFormattedAmountWithDot = cs(queryParams, prop('formattedAmountWithDot'));
export const getGameBoxView = prop("gameBoxView");
export const getGameBoxKycStatus = prop("gameBoxKycStatus");
export const getGameBoxLimitsStatus = prop("gameBoxLimitsStatus");
//query DATA
export const getSkinId = cs(queryParams, prop("skinId"));
export const getUserId = cs(queryParams, prop("userId"));
export const getToken = cs(queryParams, prop("token"));
export const getLanguage = cs(queryParams, prop("lang"));
export const getActualLanguage = cs(queryParams, prop("language"));
export const getUsername = cs(queryParams, prop("username"));
export const getTheme = cs(queryParams, prop("theme"));
export const getThemeSwitcher = cs(queryParams, prop("themeSwitcher"));
export const getLogo = cs(queryParams, prop("logo"));
export const getModuleView = cs(queryParams, prop("moduleView"));
export const getIsClubApp = cs(queryParams, prop("isClubApp"));
export const getIsButtonVisible = cs(queryParams, prop("showCloseButton"));

export const getRaces = prop("races");

export const getMiniGames = prop("miniGames");

export const getCurrentRace = cs(getRaces, (races) => {
  let currentRace = races.filter((race: { isActive: boolean }) => race.isActive);
  if (!!currentRace) {
    return currentRace.length === 1 ? currentRace[0] : currentRace;
  } else {
    return (
      races
        .filter((race: { expire_time: moment.MomentInput; }) => moment(race?.expire_time).isBefore(moment()))
        .sort((r1: { expire_time: moment.MomentInput; }, r2: { expire_time: moment.MomentInput; }) =>
          moment(r1?.expire_time).isBefore(moment(r2?.expire_time))
        )?.[0] || null
    );
  }
});

export const getMiniGamesList = cs(getMiniGames, (miniGames) => {
  return miniGames;
});

export const getGameBoxMissionActualData = cs(
  gameBoxMission,
  (g) => g.actualData
);

export const getCasinoTournamentNextInstances = cs(
  casinoTournamentNextInstances,
  (g) => g.actualData
);

export const getSelectedGameBoxTag = cs(
  selectedGameBoxTag,
  (s) => s.selected || null
);

export const getSplashMessages = cs(messages, (mss) =>
    mss.filter((m: { type: string; status: string; }) => m.type === "splash" && m.status === "unread")
);

export const getPendingFreeroundBonuss = cs(mission, (mission) => {
    let res = mission.filter((m: { bonusType: string; }) => m?.bonusType !== "deposit");
    return res.length ? res[0] : null;
});

export const getSelectedMissionId = cs(getPendingFreeroundBonuss, (mission) => {
    return mission ? mission?.missionId : null;
});

export const getGameBoxFreespins = cs(
  getGameBoxMissionActualData,
  getProgressiveMissions,
  (gm, pm) => {
    let freeSpinsMissions = gm.filter(
      (g: { categories: string | string[]; progressive_mission_id: any; }) => g?.categories?.includes("freespins") && !g?.progressive_mission_id
    );
    let freeSpinsProgressiveMissions = pm.filter((p: { categories: string | string[]; }) =>
      p?.categories?.includes("freespins")
    );
    let res = [...freeSpinsMissions, ...freeSpinsProgressiveMissions];
    return Array.isArray(res) && res?.length > 0 ? res[res?.length - 1] : null;
  }
);

export const getGameBoxGoti = cs(
  getGameBoxMissionActualData,
  getProgressiveMissions,
  (gm, pm) => {
    let gotiMissions = gm.filter(
      (g: { categories: string | string[]; progressive_mission_id: any; }) => g?.categories?.includes("goti") && !g?.progressive_mission_id
    );
    let gotiProgressiveMissions = pm.filter((p: { categories: string | string[]; }) =>
      p?.categories?.includes("goti")
    );
    let res = [...gotiMissions, ...gotiProgressiveMissions];
    return Array.isArray(res) && res?.length > 0 ? res[res?.length - 1] : null;
  }
);

export const getGameBoxBonusCode = cs(
    getGameBoxMissionActualData,
    getProgressiveMissions,
    (gm, pm) => {
        let bonusCodeMissions = gm.filter(
            (g: { categories: string | string[]; progressive_mission_id: any; }) => g?.categories?.includes("bonuscode") && !g?.progressive_mission_id
        );
        let bonusCodeProgressiveMissions = pm.filter((p: { categories: string | string[]; }) =>
            p?.categories?.includes("bonuscode")
        );
        let res = [...bonusCodeMissions, ...bonusCodeProgressiveMissions];
        return res.length ? res[0] : null;
    }
);

export const getGameBoxVip2 = cs(
    getGameBoxMissionActualData,
    getProgressiveMissions,
    (gm, pm) => {
        let vip2Missions = gm.filter(
            (g: { categories: string | string[]; progressive_mission_id: any; }) => g?.categories?.includes("vip2") && !g?.progressive_mission_id
        );
        let vip2ProgressiveMissions = pm.filter((p: { categories: string | string[]; }) =>
            p?.categories?.includes("vip2")
        );
        let res = [...vip2Missions, ...vip2ProgressiveMissions];
        return res.length ? res[0] : null;
    }
);

export const getDailyraffle = cs(
    getGameBoxMissionActualData,
    getProgressiveMissions,
    (gm, pm) => {
        let dailyraffleMissions = gm.filter(
            (g: { categories: string | string[]; progressive_mission_id: any; }) => g?.categories?.includes("Dailyraffle") && !g?.progressive_mission_id
        );
        let dailyraffleProgressiveMissions = pm.filter((p: { categories: string | string[]; }) =>
            p?.categories?.includes("Dailyraffle")
        );
        let res = [...dailyraffleMissions, ...dailyraffleProgressiveMissions];
        return res.length ? res[0] : null;
    }
);

export const getGameBoxDesaFio = cs(
    getGameBoxMissionActualData,
    getProgressiveMissions,
    (gm, pm) => {
        let desaFioMissions = gm.filter(
            (g: { categories: string | string[]; progressive_mission_id: any; }) => g?.categories?.includes("desafio") && !g?.progressive_mission_id
        );
        let desaFioProgressiveMissions = pm.filter((p: { categories: string | string[]; }) =>
            p?.categories?.includes("desafio")
        );
        let res = [...desaFioMissions, ...desaFioProgressiveMissions];
        return res.length ? res[0] : null;
    }
);

export const getGameBoxWlc2k= cs(
    getGameBoxMissionActualData,
    getProgressiveMissions,
    (gm, pm) => {
        let wlc2kMissions = gm.filter(
            (g: { categories: string | string[]; progressive_mission_id: any; }) => g?.categories?.includes("wlc2k") && !g?.progressive_mission_id
        );
        let wlc2kProgressiveMissions = pm.filter((p: { categories: string | string[]; }) =>
            p?.categories?.includes("wlc2k")
        );
        let res = [...wlc2kMissions, ...wlc2kProgressiveMissions];
        return res.length ? res[0] : null;
    }
);

export const getGameBoxDiaRioFs= cs(
    getGameBoxMissionActualData,
    getProgressiveMissions,
    (gm, pm) => {
        let diaRioFsMissions = gm.filter(
            (g: { categories: string | string[]; progressive_mission_id: any; }) => g?.categories?.includes("diariofs") && !g?.progressive_mission_id
        );
        let diaRioFsProgressiveMissions = pm.filter((p: { categories: string | string[]; }) =>
            p?.categories?.includes("diariofs")
        );
        let res = [...diaRioFsMissions, ...diaRioFsProgressiveMissions];
        return res.length ? res[0] : null;
    }
);
export const getGameBoxDepositFs= cs(
    getGameBoxMissionActualData,
    getProgressiveMissions,
    (gm, pm) => {
        let depositFsMissions = gm.filter(
            (g: { categories: string | string[]; progressive_mission_id: any; }) => g?.categories?.includes("depositfs") && !g?.progressive_mission_id
        );
        let depositFsProgressiveMissions = pm.filter((p: { categories: string | string[]; }) =>
            p?.categories?.includes("depositfs")
        );
        let res = [...depositFsMissions, ...depositFsProgressiveMissions];
        return res.length ? res[0] : null;
    }
);
export const getGameBoxWageringWof= cs(
    getGameBoxMissionActualData,
    getProgressiveMissions,
    (gm, pm) => {
        let wageringWofMissions = gm.filter(
            (g: { categories: string | string[]; progressive_mission_id: any; }) => g?.categories?.includes("wageringwof") && !g?.progressive_mission_id
        );
        let wageringWofProgressiveMissions = pm.filter((p: { categories: string | string[]; }) =>
            p?.categories?.includes("wageringwof")
        );
        let res = [...wageringWofMissions, ...wageringWofProgressiveMissions];
        return res.length ? res[0] : null;
    }
);

export const getGameBoxWofFS = cs(
  getGameBoxMissionActualData,
  getProgressiveMissions,
  (gm, pm) => {
    let wofFSMissions = gm.filter(
      (g: { categories: string | string[]; progressive_mission_id: any }) => g?.categories?.includes("wofFS") && !g?.progressive_mission_id
    );
    let wofFSProgressiveMissions = pm.filter((p: { categories: string | string[]; }) =>
      p?.categories?.includes("wofFS")
    );
    let res = [...wofFSMissions, ...wofFSProgressiveMissions];
    return Array.isArray(res) && res?.length > 0 ? res[res?.length - 1] : null;
  }
);

export const getInFreeSpinState = cs(inFreeSpinState, (f) =>
    f === "true" ? true : false
);

const initialBonusData = {
    freespins: [],
    goti: [],
    bonuscode: [],
    vip2: [],
    Dailyraffle: [],
    desafio: [],
    wlc2k: [],
    diariofs: [],
    depositfs: [],
    wageringwof: [],
    wofFS: [],
    money: [],
    race: [],
    miniGames: [],
    welcome: [],
    sportWithTeam: [],
    other: [],
    tournament: [],
  /*  raffle: [],*/
    funMission: [],
};

export const getMyBonusesData = cs(
    getGameBoxMissionActualData,
    getProgressiveMissions,
    getCurrentRace,
    getMiniGamesList,
  /*  gameBoxRaffle,*/
    (gm, pm, currentRace, miniGames, /*raffle*/) => {
        let res: any = initialBonusData;
        if ((currentRace?.length || Object.keys(currentRace)?.length) && !!currentRace && currentRace?.status !== "completed") {
            res["race"] = [currentRace];
        }
        if ((miniGames?.length || Object.keys(miniGames)?.length) && !!miniGames) {
            res["miniGames"] = [miniGames];
        }
        if (!!gm) {
            res["freespins"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; status: string }) =>
                    g?.categories?.includes("freespins") && !g?.progressive_mission_id && g?.status !== "completed"
            );
            res["goti"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; status: string }) =>
                    g?.categories?.includes("goti") && !g?.progressive_mission_id && g?.status !== "completed"
            );
            res["bonuscode"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; status: string }) =>
                    g?.categories?.includes("bonuscode") && !g?.progressive_mission_id && g?.status !== "completed"
            );
            res["vip2"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; status: string }) =>
                    g?.categories?.includes("vip2") && !g?.progressive_mission_id && g?.status !== "completed"
            );
            res["Dailyraffle"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; status: string }) =>
                    g?.categories?.includes("Dailyraffle") && !g?.progressive_mission_id && g?.status !== "completed"
            );
            res["desafio"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; status: string }) =>
                    g?.categories?.includes("desafio") && !g?.progressive_mission_id && g?.status !== "completed"
            );
            res["wlc2k"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; status: string }) =>
                    g?.categories?.includes("wlc2k") && !g?.progressive_mission_id && g?.status !== "completed"
            );
            res["diariofs"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; status: string }) =>
                    g?.categories?.includes("diariofs") && !g?.progressive_mission_id && g?.status !== "completed"
            );
            res["depositfs"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; status: string }) =>
                    g?.categories?.includes("depositfs") && !g?.progressive_mission_id && g?.status !== "completed"
            );
            res["wageringwof"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; status: string }) =>
                    g?.categories?.includes("wageringwof") && !g?.progressive_mission_id && g?.status !== "completed"
            );
            res["wofFS"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; status: string }) =>
                    g?.categories?.includes("wofFS") && !g?.progressive_mission_id && g?.status !== "completed"
            );
            res["funMission"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; }) => {
                    return g?.categories?.includes("funMission") && !g?.progressive_mission_id
                }
            );
            res["money"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; }) => g?.categories?.includes("money") && !g?.progressive_mission_id
            );
            res["tournament"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; }) =>
                    g?.categories?.includes("tourTicket") && !g?.progressive_mission_id
            );
            /*res["raffle"] = gm?.filter(
                (g: { categories: string | string[]; progressive_mission_id: any; }) =>
                    g?.categories?.includes("raffleTicket") && !g?.progressive_mission_id
            );*/
            res["other"] = gm?.filter(
                (g: { progressive_mission_id: any; categories: string | string[]; status: string }) =>
                    !g?.progressive_mission_id &&
                    !g.categories?.includes("freeSpin") &&
                    !g?.categories?.includes("money") &&
                    !g?.categories?.includes("freespins") &&
                    !g?.categories?.includes("goti") &&
                    !g?.categories?.includes("bonuscode") &&
                    !g?.categories?.includes("vip2") &&
                    !g?.categories?.includes("Dailyraffle") &&
                    !g?.categories?.includes("desafio") &&
                    !g?.categories?.includes("wlc2k") &&
                    !g?.categories?.includes("diariofs") &&
                    !g?.categories?.includes("depositfs") &&
                    !g?.categories?.includes("wageringwof") &&
                    !g?.categories?.includes("wofFS") &&
                    !g?.categories?.includes("funMission") &&
                 /*   !g?.categories?.includes("raffleTicket") &&*/
                    !g?.categories?.includes("tourTicket") &&
                    g?.status !== "completed"
            );
        }

        if (!!pm) {
            res["freespins"] = (res["freespins"] || []).concat(
                pm?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("freespins") && g?.status !== "completed")
            );
            res["goti"] = (res["goti"] || []).concat(
                pm?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("goti") && g?.status !== "completed")
            );
            res["bonuscode"] = (res["bonuscode"] || []).concat(
                pm?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("bonuscode") && g?.status !== "completed")
            );
            res["vip2"] = (res["vip2"] || []).concat(
                pm?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("vip2") && g?.status !== "completed")
            );
            res["Dailyraffle"] = (res["Dailyraffle"] || []).concat(
                pm?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("Dailyraffle") && g?.status !== "completed")
            );
            res["desafio"] = (res["desafio"] || []).concat(
                pm?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("desafio") && g?.status !== "completed")
            );
            res["wlc2k"] = (res["wlc2k"] || []).concat(
                pm?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("wlc2k") && g?.status !== "completed")
            );
            res["diariofs"] = (res["diariofs"] || []).concat(
                pm?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("diariofs") && g?.status !== "completed")
            );
            res["depositfs"] = (res["depositfs"] || []).concat(
                pm?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("depositfs") && g?.status !== "completed")
            );
            res["wageringwof"] = (res["wageringwof"] || []).concat(
                pm?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("wageringwof") && g?.status !== "completed")
            );
            res["wofFS"] = (res["wofFS"] || []).concat(
                pm?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("wofFS") && g?.status !== "completed")
            );
            res["money"] = (res["money"] || []).concat(
                pm?.filter((g: { categories: string | string[]; }) => g?.categories?.includes("money"))
            );
            res["welcome"] = pm?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("welcome") && g?.status !== "completed");
            res["sportWithTeam"] = pm?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("sportWithTeam") && g?.status !== "completed");
            res["other"] = (res["other"] || []).concat(
                pm?.filter(
                    (pm: { categories: string | string[]; status: string }) =>
                        !pm?.categories?.includes("freeSpin") &&
                        !pm?.categories?.includes("money") &&
                        !pm?.categories?.includes("freespins") &&
                        !pm?.categories?.includes("goti") &&
                        !pm?.categories?.includes("bonuscode") &&
                        !pm?.categories?.includes("vip2") &&
                        !pm?.categories?.includes("Dailyraffle") &&
                        !pm?.categories?.includes("desafio") &&
                        !pm?.categories?.includes("wlc2k") &&
                        !pm?.categories?.includes("diariofs") &&
                        !pm?.categories?.includes("depositfs") &&
                        !pm?.categories?.includes("wageringwof") &&
                        !pm?.categories?.includes("wofFS") &&
                        !pm?.categories?.includes("welcome") &&
                        !pm?.categories?.includes("sportWithTeam") &&
                         pm?.status !== "completed"
                )
            );
        }
       /* if (Array.isArray(res["raffle"]) && raffle?.actualData) {
            res["raffle"][0] = {
                ...res["raffle"][0],
                prizePool: raffle?.actualData?.prizePool,
                currency: raffle?.actualData?.currency
            };
        }*/

        const sortedBonus = {};
        Object.keys(res)
            .sort((t1, t2) => res[t2]?.length - res[t1]?.length)
            .map((item) => (sortedBonus[item] = res[item]));
        return sortedBonus;
    }
);


export const getCurrentProgresiveMission = cs(
  getMyBonusesData,
  (myBonusesData) => {
    let inProgressOrOptMission = myBonusesData["welcome"]?.find(
      (m: { status: string; }) => m.status === "inProgress" || m.status === "optInRequired"
    );

    if (!inProgressOrOptMission) {
        inProgressOrOptMission = myBonusesData["welcome"][0];
    }
    const currentMissionData = inProgressOrOptMission?.submissions?.find(
      (m: { status: string; }) => m?.status === "inProgress" || m.status === "optInRequired"
    );
    if (currentMissionData) {
      currentMissionData["goal"] = currentMissionData?.trigger?.points;
    }
    return currentMissionData;
  }
);

export const getSportWithTeamMission = cs(
  getMyBonusesData,
  (myBonusesData) => {
    let inProgressSportWithTeam = myBonusesData["sportWithTeam"]?.find(
      (m: { status: string; }) => m.status === "inProgress"
    );
    if (!inProgressSportWithTeam) {
        inProgressSportWithTeam = myBonusesData["sportWithTeam"][0];
    }
    const currentMissionData = inProgressSportWithTeam?.submissions?.find(
      (m: { status: string; }) => m?.status === "inProgress" || m?.status === "selectSportTeamToStart"
    );
    if (currentMissionData) {
      currentMissionData["goal"] = currentMissionData?.trigger?.points;
    }

    return currentMissionData;
  }
);

export const getGameBoxRaffleMission = cs(
  getGameBoxMissionActualData,
  (gm) => {
    let res = gm.filter((g: { categories: string | string[]; }) => g.categories.includes("raffleTicket"));
    return res.length ? res : null;
  }
);

export const getPendingFreeroundBonus = cs(mission, (mission) => {
    let res = mission.filter((m: { bonusType: string; }) => m?.bonusType !== "deposit");
    return res.length ? res[0] : null;
});

export const getGameBoxOtherFirstTagMission = cs(
  getGameBoxMissionActualData,
  getProgressiveMissions,
  (gm,progressiveMissions) => {
      let res = [
          ...gm.filter((g: { categories: string | string[] }) =>
              Array.isArray(g.categories) && g.categories.includes("other")
          ),
          ...progressiveMissions.filter((g: { categories: Array<null | string> | null }) =>
              Array.isArray(g.categories) && (g.categories.includes(null) || g.categories.includes("other"))
          )
      ];
    return res[0] || null;
  }
);

/*export const getGameBoxRaffleTickets = cs(gameBoxRaffleTickets, (g) => {
    return g?.length ? g : [];
});*/


export const getGameBoxWagering = cs(getGameBoxMissionActualData, (gm) => {
  let res = gm.filter(
    (g: { categories: string | string[]; }) =>
      g.categories.includes('money')
  );
  return res.length ? res[0] : null;
});

export const getGameBoxFunMission = cs(getGameBoxMissionActualData,getGameInfo, (gm, gameInfo)  => {
    let res = gm.filter(
    (g: { categories: string | string[]; id: any; }) =>
      g.categories.includes('funMission') && gameInfo.bonusMissionId === g.id
  );
  return res.length ? res[0] : null;
});

export const getTournamentGameBoxMission = cs(
  getGameBoxMissionActualData,
  (missions) => {
    const result = missions.filter((m: { categories: string | string[]; }) => m.categories.includes("tourTicket")) || [];
    return result.length ? result : null;
  }
);

export const getCasinoTournamentNextInstance = cs(
    casinoTournamentNextInstances,
    (g) => g.actualData?.[0]
);

export const getAllGameBoxWageringMissions = cs(
    getGameBoxMissionActualData,
    (gm) => {
        let res = gm.filter(
            (g: { categories: string | string[]; progressive_mission_id: any; }) =>
                (g.categories.includes('money') && !g.progressive_mission_id)
        );
        return res.length ? res : null;
    }
);

export const getActiveGameBoxCategoriesUnique = cs(
  getGameBoxMissionActualData,
  getProgressiveMissions,
  getCurrentRace,
  getGameBoxView,
  getMiniGamesList,
  (
    mission,
    progressiveMissions,
    race,
    gameBoxView,
    miniGames,
  ) => {
    const missionCategories = getAllCategoriesWithoutProgressive(mission,[]);
    const allMissions = getAllCategories(progressiveMissions, missionCategories, gameBoxView);
    const uniqMissions = Array.from(new Set(allMissions));
    if (race && (race?.length > 0 || Object.keys(race)?.length > 0)) {
      uniqMissions.push("race");
    }
    if (miniGames && (miniGames?.length > 0 || Object.keys(miniGames)?.length > 0)) {
      uniqMissions.push("miniGames");
    }
      return uniqMissions.map(item => {
          if (item === "tourTicket") return "tournament";
         // if (item === "raffleTicket") return "raffle";
          return item;
      });
  }
)

export const getSelectedGameBoxData = cs(
    getCasinoTournamentNextInstance, // getting tournamentData and prizePool information
  /*  getGameBoxRaffleMission, // getting raffle missions data*/
    getTournamentGameBoxMission, // getting tournament missions data
    getGameBoxFreespins, // getting freespins missions data
    getGameBoxWagering, // getting all wagering missions datas
    getSelectedGameBoxTag, // gettting selected tag,
   /* getGameBoxRaffleTickets,*/
    getCurrentProgresiveMission,
    getSportWithTeamMission,
    getMyBonusesData,
    getCurrentRace,
    getMiniGamesList,
    getGameBoxOtherFirstTagMission,
    getGameBoxFunMission,
    (
        tournamentNextInstanceData,
       /* raffle,*/
        instance,
        freespins,
        wageringMissions,
        selected,
      /*  raffleTicketsAndPrize,*/
        progressiveMission,
        sportWithTeamMission,
        myBonusesData,
        races,
        miniGames,
        other,
        funMission
    ) => {
        switch (selected) {
            /*case "raffle":
                const raffleMissions = mergeArrays(raffle, raffleTicketsAndPrize);
                return raffle ? raffleMissions : null;*/
            case "tournament":
                return instance?.length
                    ? tournamentNextInstanceData
                        ? {
                            ...transformForAllGameBoxData(instance[0]),
                            ...tournamentNextInstanceData,
                            ...transformPrizePoolData(tournamentNextInstanceData),
                        }
                        : { ...transformForAllGameBoxData(instance[0]) }
                    : null;
            case "freespins":
                return transformFreeRoundsData(myBonusesData["freespins"]?.[0]) || null;
            case "goti":
                return transformFreeRoundsData(myBonusesData["goti"]?.[0]) || null;
            case "bonuscode":
                return transformFreeRoundsData(myBonusesData["bonuscode"]?.[0]) || null;
            case "vip2":
                return transformFreeRoundsData(myBonusesData["vip2"]?.[0]) || null;
            case "Dailyraffle":
                return transformFreeRoundsData(myBonusesData["Dailyraffle"]?.[0]) || null;
            case "desafio":
                return transformFreeRoundsData(myBonusesData["desafio"]?.[0]) || null;
            case "wlc2k":
                return transformFreeRoundsData(myBonusesData["wlc2k"]?.[0]) || null;
            case "diariofs":
                return transformFreeRoundsData(myBonusesData["diariofs"]?.[0]) || null;
            case "depositfs":
                return transformFreeRoundsData(myBonusesData["depositfs"]?.[0]) || null;
            case "wageringwof":
                return transformFreeRoundsData(myBonusesData["wageringwof"]?.[0]) || null;
            case "wofFS":
                return transformFreeRoundsData(myBonusesData["wofFS"]?.[0]) || null;
            case "money":
                return wageringMissions && Object.keys(wageringMissions)?.length > 0
                    ? transformForAllGameBoxData(wageringMissions)
                    : null;
            case "progressiveMissions":
            case "welcome":
                return progressiveMission;
            case "sportWithTeam":
                return sportWithTeamMission;
            case "race":
                return races;
            case "miniGames":
                return miniGames;
            case "funMission":
                return transformForAllGameBoxData(funMission);
            case 'other':
                return other;
            default:
                return freespins;
        }
    }
);

export const getActiveGameBoxTags = cs(
  /*  getGameBoxRaffleMission,*/
    getTournamentGameBoxMission,
    getGameBoxFreespins,
    getGameBoxGoti,
    getGameBoxBonusCode,
    getGameBoxVip2,
    getDailyraffle,
    getGameBoxDesaFio,
    getGameBoxWlc2k,
    getGameBoxDiaRioFs,
    getGameBoxDepositFs,
    getGameBoxWageringWof,
    getGameBoxWofFS,
    getAllGameBoxWageringMissions,
    getPendingFreeroundBonus,
    getProgressiveMissions,
    getRaces,
    getMiniGamesList,
    getGameBoxMissionActualData,
    getGameInfo,
    (
      /*  raffle,*/
        tournament,
        freespin,
        goti,
        bonuscode,
        vip2,
        Dailyraffle,
        desafio,
        wlc2k,
        diariofs,
        depositfs,
        wageringwof,
        wofFS,
        deposit,
        freespinBonus,
        progressive,
        races,
        miniGames,
        gameBoxMissionData,
        gameInfo,
    ) => {
        let array: any = [];
        if(!!gameInfo.bonusMissionId) return ['funMission'];
      /*  if (raffle) array.push("raffle");*/
        if (tournament?.length) array.push("tournament");
        if (deposit?.length) array.push("money");
        const freespins = freespin || freespinBonus;
        if (freespins && !freespins?.isGameboxInvisible && freespins?.status !== "completed") array.push("freespins");
        if (goti && !goti?.isGameboxInvisible && goti?.status !== "completed") array.push("goti");
        if (bonuscode && !bonuscode?.isGameboxInvisible && bonuscode?.status !== "completed") array.push("bonuscode");
        if (vip2 && !vip2?.isGameboxInvisible && vip2?.status !== "completed") array.push("vip2");
        if (Dailyraffle && !Dailyraffle?.isGameboxInvisible && Dailyraffle?.status !== "completed") array.push("Dailyraffle");
        if (desafio && !desafio?.isGameboxInvisible && desafio?.status !== "completed") array.push("desafio");
        if (wlc2k && !wlc2k?.isGameboxInvisible && wlc2k?.status !== "completed") array.push("wlc2k");
        if (diariofs && !diariofs?.isGameboxInvisible && diariofs?.status !== "completed") array.push("diariofs");
        if (depositfs && !depositfs?.isGameboxInvisible && depositfs?.status !== "completed") array.push("depositfs");
        if (wageringwof && !wageringwof?.isGameboxInvisible && wageringwof?.status !== "completed") array.push("wageringwof");
        if (wofFS && !wofFS?.isGameboxInvisible && wofFS?.status !== "completed") array.push("wofFS");
        if (progressive.filter((m: { categories: string | string[]; }) => m.categories?.includes("welcome"))?.length)
            array.push("welcome");
        if (progressive.filter((m: { categories: string | string[]; }) => m.categories?.includes("sportWithTeam"))?.length)
            array.push("sportWithTeam");
        if(gameBoxMissionData.some((a: { categories: string | string[]; })=> a.categories.includes('other'))) array.push('other');
        let activeRaces = races.filter((race: { isActive: boolean }) => race.isActive);
        if (races?.length > 0 && activeRaces?.length > 0) {
            array.push("race");
        }
        if (miniGames && miniGames?.length > 0) {
            array.push("miniGames");
        }
        return array;
    }
);

export const getRacesLeaderboard = prop("racesLeaderboard");

export const getRacePrizeList = cs(
    getCurrentRace,
    getRacesLeaderboard,
    (currentRace, leaderBoard) => {
        const raceId = localStorage.getItem('raceId') as string;
        const isCurrentRaceArray = Array.isArray(currentRace);
        const selectedRace = isCurrentRaceArray ? currentRace.find((race: { id: number }) => race.id === +raceId) : currentRace;
        const prizeList = {};
        leaderBoard?.data?.map((player: { rank: number; }) => {
            selectedRace?.prizeStructure?.headers?.map((award: { place_from: number; place_to: number; prize: { type: string; amount: number | undefined; percent: number; currency: string | undefined; description:string }; }) => {
                if (
                    isBetweenOrEqual(player?.rank, award?.place_from, award?.place_to)
                ) {
                    prizeList[player?.rank] = award?.prize?.type === "money" ? formatCurrencyConverter(
                        award?.prize?.type === "money"
                            ? award?.prize?.amount
                            : (award.prize?.percent * selectedRace?.prize_pool) / 100,
                        award?.prize?.currency
                    ) : award?.prize?.description
                }
            });
        });
        return prizeList;
    }
);

export const getExpiredGameMissionData = cs(
    getExpiredProgressiveMissions,
    (pm) => {
        let res: any = initialBonusData;
        const missions = pm?.data;
        if (!!missions) {
            res["freespins"] = (res["freespins"] || []).concat(
                missions?.filter((g: { categories: string | string[]; status: string}) => g?.categories?.includes("freespins") && g?.status === "expired")
            );
            res["goti"] = (res["goti"] || []).concat(
                missions?.filter((g: { categories: string | string[]; status: string}) => g?.categories?.includes("goti") && g?.status === "expired")
            );
            res["bonuscode"] = (res["bonuscode"] || []).concat(
                missions?.filter((g: { categories: string | string[]; status: string}) => g?.categories?.includes("bonuscode") && g?.status === "expired")
            );
            res["wofFS"] = (res["wofFS"] || []).concat(
                missions?.filter((g: { categories: string | string[]; status: string}) => g?.categories?.includes("wofFS") && g?.status === "expired")
            );
            res["money"] = (res["money"] || []).concat(
                missions?.filter((g: { categories: string | string[]; }) => g?.categories?.includes("money"))
            );
            res["welcome"] = missions?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("welcome") && g?.status === "expired");
            res["sportWithTeam"] = missions?.filter((g: { categories: string | string[]; status: string }) => g?.categories?.includes("sportWithTeam") && g?.status === "expired");
            res["other"] = (res["other"] || []).concat(
                missions?.filter(
                    (m: { categories: string | string[]; status: string }) =>
                        !m?.categories?.includes("freeSpin") &&
                        !m?.categories?.includes("money") &&
                        !m?.categories?.includes("freespins") &&
                        !m?.categories?.includes("goti") &&
                        !m?.categories?.includes("bonuscode") &&
                        !m?.categories?.includes("wofFS") &&
                        !m?.categories?.includes("welcome") &&
                        !m?.categories?.includes("sportWithTeam") &&
                        m?.status === "expired"
                )
            );
        }
        const sortedBonus = {};
        Object.keys(res)
            .sort((t1, t2) => res[t2]?.length - res[t1]?.length)
            .map((item) => (sortedBonus[item] = res[item]));
        return {
            data: sortedBonus,
            fetched: pm?.fetched ?? false,
        };
    }
);

export const getDefaultGameBoxCategory = cs(
    getInFreeSpinState,
    /*getGameBoxRaffleMission,*/
    getTournamentGameBoxMission,
    getGameBoxWagering,
    getGameBoxFreespins,
    getGameBoxGoti,
    getGameBoxBonusCode,
    getGameBoxVip2,
    getDailyraffle,
    getGameBoxDesaFio,
    getGameBoxWlc2k,
    getGameBoxDiaRioFs,
    getGameBoxDepositFs,
    getGameBoxWageringWof,
    getGameBoxWofFS,
    getCurrentProgresiveMission,
    getSportWithTeamMission,
    getActiveGameBoxTags,
    (
        inFreeSpinState,
      /*  raffle,*/
        tournament,
        wagering,
        freespins,
        goti,
        bonuscode,
        vip2,
        Dailyraffle,
        desafio,
        wlc2k,
        diariofs,
        depositfs,
        wageringwof,
        wofFS,
        progressive,
        sportWithTeamMission,
        activeGameBoxTags,
    ) => {
        if (configs.showOnlyActiveGameBoxTag) {
            return activeGameBoxTags[0];
        }
        if (inFreeSpinState) {
            return "freespins";
        } /*else if (raffle) {
            return "raffle";
        }*/ else if (tournament?.length) {
            return "tournament";
        } else if (wagering) {
            return "money";
        } else if (freespins) {
            return "freespins";
        } else if (goti) {
            return "goti";
        } else if (bonuscode) {
            return "bonuscode";
        } else if (vip2) {
            return "vip2";
        } else if (Dailyraffle) {
            return "Dailyraffle";
        } else if (desafio) {
            return "desafio";
        } else if (wlc2k) {
            return "wlc2k";
        } else if (diariofs) {
            return "diariofs";
        } else if (depositfs) {
            return "depositfs";
        } else if (wageringwof) {
            return "wageringwof";
        } else if (wofFS) {
            return "wofFS";
        } else if (progressive) {
            return "welcome";
        } else if (sportWithTeamMission) {
            return "sportWithTeam";
        }/* else {
            return "raffle";
        }*/
    }
);

export const getCurrentRaceLength = cs(getRaces, (races) => {
    let currentRace = races.find((race: { isActive: any }) => race.isActive);
    if (!!currentRace) {
        return 1;
    } else {
        return (
            races
                .filter((race: { expire_time: moment.MomentInput }) => moment(race?.expire_time).isBefore(moment()))
                .sort((r1: { expire_time: moment.MomentInput }, r2: { expire_time: moment.MomentInput }) =>
                    moment(r1?.expire_time).isBefore(moment(r2?.expire_time))
                )?.length || 0
        );
    }
});

export const getRaceLeaderBoardLimit = prop("raceLeaderBoardLimit");
export const getRacePointsUpdated = prop("raceTemplateUpdate");
